import { render } from "./RecursiveForm.vue?vue&type=template&id=cb9e308e&ts=true"
import script from "./RecursiveForm.vue?vue&type=script&lang=ts"
export * from "./RecursiveForm.vue?vue&type=script&lang=ts"

import "./RecursiveForm.vue?vue&type=style&index=0&id=cb9e308e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__